module.exports = __webpack_public_path__ + "img/AlamovsNZA.8be0f56e.png";